<input type="text" [name]="name" [id]="name" [ngClass]="{'hidden-field': show === undefined}" [value]="value" />
